import {
  configApiRef,
  createApiFactory,
  createApiRef,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  identityApiRef,
  microsoftAuthApiRef,
} from '@backstage/core-plugin-api';
import { customerExperienceRouteRef } from './routes';
import { cuxApiRef, CuXService } from './api/CuXService';
import {
  CommonProductService,
  ICommonProductService,
} from '@dewise-devex/backstage-plugin-product-common';
import {
  CommonAdoService,
  ICommonAdoService,
} from '@dewise-devex/backstage-plugin-azdevops-common';

export const commonProductApiRef = createApiRef<ICommonProductService>({
  id: 'plugin.customer-experience-products.client',
});

export const commonAzDevOpsApiRef = createApiRef<ICommonAdoService>({
  id: 'plugin.customer-experience-azdevops.client',
});

export const customerExperiencePlugin = createPlugin({
  id: 'customer-experience',
  apis: [
    createApiFactory({
      api: cuxApiRef,
      deps: {
        identityApi: identityApiRef,
        discoveryApi: discoveryApiRef,
        configApi: configApiRef,
      },
      factory: deps => new CuXService(deps),
    }),
    createApiFactory({
      api: commonProductApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        identityApi: identityApiRef,
      },
      factory: deps => new CommonProductService(deps),
    }),
    createApiFactory({
      api: commonAzDevOpsApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        identityApi: identityApiRef,
        authApi: microsoftAuthApiRef,
      },
      factory: deps =>
        new CommonAdoService(deps, '499b84ac-1321-427f-aa17-267ca6975798'),
    }),
  ],
  routes: {
    root: customerExperienceRouteRef,
  },
});

export const CustomerExperiencePage = customerExperiencePlugin.provide(
  createRoutableExtension({
    name: 'CustomerExperiencePage',
    component: () => import('./components/index').then(m => m.IndexPage),
    mountPoint: customerExperienceRouteRef,
  }),
);
